import React from "react";
import "./Monetize.css";
import monetize from "../../Images/Image (7).png";

function Monetise() {
  return (
    <div className="main-container">
      <div className="monetization-playground">
        <div className="left-content">
          <span className="monetizebadge">Businessbay Store</span>
          <h1>A Rewarding Partnership</h1>
          <p className="monetizep">
            When your audience shops through your link, you earn a share of
            every sale. This collaboration is built for mutual success—your
            influence, our platform, and a win for everyone.
          </p>
        </div>
        <div className="right-image">
          <img src={monetize} className="monetize-image"  alt="monetize"/>
        </div>
      </div>
    </div>
  );
}

export default Monetise;
